const vueInst = new Vue({
	el: '#vue-wrap',
	data: {
		mid: null,
		page: 1,
		rows: 10,
		totalPage: 1,
		newsList: [],
		bdList: [],
		fList: []
	},
	methods: {
		getNews: function () {
            axios.post(baseURL + 'getInfomation?type=22&rows=10&page=' + this.page)
				.then(res => {
					if (res.code == 200) {
						this.newsList = this.newsList.concat(res.list);
						this.totalPage = Math.ceil(res.total / this.rows);
					}
				})
				.catch(err => console.log(err));
		},
        loadMore: function () {
			this.page ++;
            this.getNews();
		}
	},
	mounted: function () {
		this.getNews();
	}
});